import React, { useEffect, useState } from 'react';

import { Entity, Cell } from '../types';
import { inputs } from '@ecosystem/newron-design-system';
import { Footer } from './Footer';
import { CellList } from './CellList';

const { CheckboxState } = inputs;
const LOADING_OPACITY = 50;
const LOADED_OPACITY = 1;
const DEFAULT_COLUMNS = 2;

type MulticellSelectorContainerProps = {
  onClose: () => void;
  onApply: (value: Entity[]) => void;
  cells: Cell[];
  isLoading: boolean;
  selected: Entity[];
  showLastMonth?: boolean;
  showLastWeek?: boolean;
  primaryBtnText?: string;
  isCancelDisabled?: boolean;
};
export const MultiCellSelectorContainer = ({
  onClose,
  onApply,
  cells,
  isLoading,
  selected,
  showLastMonth,
  showLastWeek,
  primaryBtnText,
  isCancelDisabled = false,
}: MulticellSelectorContainerProps) => {
  const [selectedCells, setSelectedCells] = useState<Cell[]>([]);

  useEffect(() => {
    const initialSelectedMarket = cells.reduce((initialSelectedMarket, market) => {
      if (selected && selected.find(cell => cell.value === market.value)) {
        initialSelectedMarket.push(market);
      }
      return initialSelectedMarket;
    }, []);
    setSelectedCells(initialSelectedMarket);
  }, [cells, selected]);

  const onMarketCheckboxChange = (isSelected: boolean, market: Cell) => {
    if (isSelected) {
      setSelectedCells(prev => [...prev, market]);
    } else {
      setSelectedCells(prev => prev.filter(p => p.value !== market.value));
    }
  };

  const AllMarketCheckboxChange = (state: inputs.CheckboxState, markets: Cell[]) => {
    if (state === CheckboxState.UNCHECKED) {
      setSelectedCells([]);
    } else {
      setSelectedCells(markets);
    }
  };

  const handleApply = () => {
    const cells = selectedCells.map(sm => {
      return { value: `${sm.countryCode}-${sm.productCode}`, label: `${sm.productName} in ${sm.countryName}` };
    });

    onApply(cells);

    onClose();
  };
  const numberOfColumns = [showLastMonth, showLastWeek].filter(item => item).length + DEFAULT_COLUMNS;
  const columnWidthMap = {
    2: 'cell-selector-width-two-column',
    3: 'cell-selector-width-three-column',
    4: 'w-192',
  };

  return (
    <div
      className={`multicell-selector-container relative flex-column flex ${columnWidthMap[numberOfColumns]} opacity-${
        isLoading ? LOADING_OPACITY : LOADED_OPACITY
      }`}
      data-test-id="multicell-selector-container"
    >
      <>
        <CellList
          isLoading={isLoading}
          cells={cells}
          selectedCells={selectedCells}
          onChange={onMarketCheckboxChange}
          onAllChange={AllMarketCheckboxChange}
          showLastMonth={showLastMonth}
          showLastWeek={showLastWeek}
        />
        <Footer
          handleApply={handleApply}
          handleCancel={onClose}
          selectedCells={selectedCells}
          primaryBtnText={primaryBtnText}
          isCancelDisabled={isCancelDisabled}
        />
      </>
    </div>
  );
};
